<template>
    <div class="marker-place bg-body" :class="{open: isOpen}">
        <header class="d-flex align-items-center p-4" @click="toggle">

            <div class="d-flex flex-column">
                <slot name="title"></slot>
            </div>

            <span 
                v-if="!!this.$slots.default"
                class="icon icon-right-open-big text-xl text-gray-light ml-auto">
            </span>

        </header>

        <div class="marker-place-content-wrapper bg-gray-lightest">
            <div class="marker-place-content p-4">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: { type: String, required: true },
            lat: { type: String, required: true },
            lng: { type: String, required: true },
        },

        data: function () {
            return {
                isOpen: false,
                content: null,
                contentWrapper: null,
            }
        },

        computed: {
            hasDefaultSlot () {
                return !!this.$slots.default;
            },
        },

        created: function () {
            bus.$on( 'tabbed-menu-item-selected', ( type ) => {
                if ( type === this.type ) {
                    bus.$emit( 'marker-place-add', this );
                } else {
                    bus.$emit( 'marker-place-remove', this );
                }
                this.isOpen = false;
            });
        },

        mounted: function () {
            this.content = $(this.$el).find('.marker-place-content');
            this.contentWrapper = $(this.$el).find('.marker-place-content-wrapper');

            bus.$on( 'marker-place-toggle', ( markerPlace, selected ) => {
                if ( markerPlace !== this ) {
                    this.isOpen = false;
                    if ( this.hasDefaultSlot ) {
                        this.contentWrapper.css({
                            'height': 0,
                        });
                    }
                }
            });
        },

        methods: {
            toggle: function () {
                if ( this.hasDefaultSlot ) {
                    this.contentWrapper.css({
                        'height': this.isOpen ? 0 : this.content.outerHeight(),
                    });
                }

                this.isOpen = !this.isOpen;
                bus.$emit( 'marker-place-toggle', this, this.isOpen );
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .marker-place {
        color: $gray-dark;
        border: .0625rem solid $gray-lighter;
        border-top: none;

        header {

            .icon {
                transition: transform .5s ease-in-out;
                transform: rotate3d(0, 0, 1, 0deg);
            }
        }
        .marker-place-content-wrapper {
            height: 0;
            overflow: hidden;
            transition: height .5s ease-in-out;

            &:before {
                content: '';
                display: block;
                border-top: .0625rem solid $gray-lighter;
            }
        }

        &.open {
            .icon {
                transform: rotate3d( 0, 0, 1, 90deg );
            }
        }
        
        &:hover {
            border-left: .25rem solid $green-light;
        }

    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MarkerPlace.vue